

import React, { useEffect, useState } from "react";
import './Category.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal, Button } from 'react-bootstrap'; 

const Category = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [catTitle, setCatTitle] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [formError, setFormError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch("https://api.biznetusa.com/api/get-category");
                if (!response.ok) {
                    throw new Error("Failed to fetch categories");
                }
                const result = await response.json();
                setCategories(result.categories);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchCategories();
    }, []);

    const handleAddCategory = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError(null);

        try {
            const response = await fetch("https://api.biznetusa.com/api/store-category", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    cat_title: catTitle
                })
            });

            const result = await response.json();

            if (response.ok) {
                setCategories([...categories, result.category]);
                setShowModal(false);
                setCatTitle('');
                toast.success("Category added successfully!");
            } else {
                if (result.errors && result.errors.cat_title) {
                    setFormError(result.errors.cat_title[0]);
                } else {
                    setFormError("An unexpected error occurred.");
                }
            }
        } catch (err) {
            setFormError("Failed to add category.");
            toast.error("Failed to add category.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleUpdateCategory = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError(null);

        try {
            const response = await fetch(`https://api.biznetusa.com/api/update-category/${selectedCategory.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    cat_title: catTitle
                })
            });

            const result = await response.json();

            if (response.ok) {
                setCategories(
                    categories.map((category) =>
                        category.id === selectedCategory.id ? { ...category, cat_title: catTitle } : category
                    )
                );
                setShowModal(false);
                setSelectedCategory(null);
                setCatTitle('');
                toast.success("Category updated successfully!");
            } else {
                if (result.errors && result.errors.cat_title) {
                    setFormError(result.errors.cat_title[0]);
                } else {
                    setFormError("An unexpected error occurred.");
                }
            }
        } catch (err) {
            setFormError("Failed to update category.");
            toast.error("Failed to update category.");
        } finally {
            setIsSubmitting(false);
        }
    };

    
    const handleEditClick = (category) => {
        setSelectedCategory(category);
        setCatTitle(category.cat_title);
        setShowModal(true);
    };

    
    const handleDeleteCategory = async (categoryId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this category?");
        if (!confirmDelete) return;

        try {
            const response = await fetch(`https://api.biznetusa.com/api/deletecategory/${categoryId}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json"
                }
            });

            if (response.ok) {
                setCategories(categories.filter(category => category.id !== categoryId));
                toast.success("Category deleted successfully!");
            } else {
                toast.error("Failed to delete category.");
            }
        } catch (err) {
            toast.error("Error deleting category.");
        }
    };

    if (error) {
        return <p>Error fetching categories: {error}</p>;
    }

    return (
        <>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-1 ">
                    </div>
                    <div className="col-lg-12">
                        <div className="d-flex justify-content-between align-items-center mt-2">
                            <h4>Category List</h4>
                            <Button onClick={() => { setShowModal(true); setSelectedCategory(null); setCatTitle(''); }}>
                                Add Category
                            </Button>
                        </div>

                        <div className="category-table-container mt-3">
                            <table className="category-table table">
                                <thead>
                                    <tr>
                                        <th>Category Title</th>
                                        <th>Slug</th>
                                        <th>Subcategories</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categories.length > 0 ? (
                                        categories.map((category) => (
                                            <tr key={category.id}>
                                                <td>{category.cat_title}</td>
                                                <td>{category.slug}</td>
                                                <td>
                                                    {category.sub_categories.length > 0 ? (
                                                        <ul>
                                                            {category.sub_categories.map((subCategory) => (
                                                                <li key={subCategory.id}>{subCategory.sub_title}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p>No subcategories available.</p>
                                                    )}
                                                </td>
                                                <td>
                                                    <Button variant="warning" className="me-2" onClick={() => handleEditClick(category)}>
                                                        Edit
                                                    </Button>
                                                    <Button variant="danger" onClick={() => handleDeleteCategory(category.id)}>
                                                        Delete
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4">No categories available.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/Edit Category Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedCategory ? "Edit Category" : "Add New Category"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formError && <p className="text-danger">{formError}</p>}
                    <form onSubmit={selectedCategory ? handleUpdateCategory : handleAddCategory}>
                        <div className="form-group">
                            <label>Category Title</label>
                            <input
                                type="text"
                                className="form-control"
                                value={catTitle}
                                onChange={(e) => setCatTitle(e.target.value)}
                                required
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setShowModal(false); setSelectedCategory(null); }}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={selectedCategory ? handleUpdateCategory : handleAddCategory} disabled={isSubmitting}>
                        {isSubmitting ? "Saving..." : selectedCategory ? "Update Category" : "Add Category"}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Toast Container */}
            <ToastContainer />
        </>
    );
};

export default Category;
